(() => {
  function initialize(root) {
    if (root.dataset.mixReady === 'true') return;
    root.dataset.mixReady = 'true';
    const packSize = Number(root.dataset.packSize);
    const rows = [...root.querySelectorAll('[data-mix-item]')].map((element) => ({
      element, id: Number(element.dataset.variantId), max: Number(element.dataset.max), count: 0,
    }));
    const submit = root.querySelector('[data-mix-submit]');
    const status = root.querySelector('[data-mix-status]');
    const error = root.querySelector('[data-mix-error]');
    const rootUrl = window.Shopify?.routes?.root || '/';
    let busy = false;
    function total() {
      return rows.reduce((sum, row) => sum + row.count, 0);
    }
    function render() {
      const selected = total();
      rows.forEach((row) => {
        row.element.querySelector('[data-mix-count]').textContent = row.count;
        row.element.querySelector('[data-mix-minus]').disabled = busy || row.count === 0;
        row.element.querySelector('[data-mix-plus]').disabled = busy || selected >= packSize || row.count >= row.max;
      });
      status.textContent = selected === packSize
        ? packSize + ' av ' + packSize + ' poser valgt'
        : (packSize - selected) + ' poser igjen å velge';
      submit.disabled = busy || selected !== packSize;
    }
    rows.forEach((row) => {
      row.element.querySelector('[data-mix-minus]').addEventListener('click', () => {
        if (row.count > 0 && !busy) row.count--;
        render();
      });
      row.element.querySelector('[data-mix-plus]').addEventListener('click', () => {
        if (total() < packSize && row.count < row.max && !busy) row.count++;
        render();
      });
    });
    submit.addEventListener('click', async () => {
      if (busy || total() !== packSize) return;
      busy = true;
      error.hidden = true;
      const originalLabel = submit.textContent;
      submit.textContent = 'Legger i handlekurven…';
      render();
      try {
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: rows.filter((row) => row.count > 0).map((row) => ({ id: row.id, quantity: row.count })) }),
        });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Kunne ikke legge til varene.');
        }
        window.location.assign(rootUrl + 'cart');
      } catch (caught) {
        error.textContent = caught.message || 'Noe gikk galt. Prøv igjen.';
        error.hidden = false;
        busy = false;
        submit.textContent = originalLabel;
        render();
      }
    });
    render();
  }
  function initializeAll() {
    document.querySelectorAll('[data-nordals-mix]').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
